import React, { useEffect, useState } from "react";
import {
  Container,
  Form,
  Button,
  Card,
  InputGroup,
  Alert,
} from "react-bootstrap";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { apibasePath } from "../config";
const Admin = () => {
  const [showPassword, setShowPassword] = useState(true);
  const [adminLogin, setAdminLogin] = useState({ username: "", password: "" });
  const [errors, setErrors] = useState({ username: "", password: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [item, setItem] = useState("Admin Login");
  const [errorMessage, setErrorMessage] = useState("");
  const [logo, setLogo] = useState(null);
  const [brandLogo, setBrandLogo] = useState(null);
  const navigate = useNavigate();

  const API_URL = `${apibasePath}/client/profile-login/`;
  const Api_url = `${apibasePath}/client/profiles/company/`;

  //brandlogo
  const Api = `${apibasePath}/client/profiles/brand/`;

  useEffect(() => {
    const fetchdata = async () => {
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);
  //logo
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        let response = await axios.get(Api_url, {
          headers: { "Content-Type": "application/json" },
        });
        setLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };
    fetchLogo();
  }, []);

  const validateForm = () => {
    let isValid = true;
    let newErrors = { username: "", password: "" };

    if (!adminLogin.username.trim()) {
      newErrors.username = "Username is required.";
      isValid = false;
    }

    if (!adminLogin.password.trim()) {
      newErrors.password = "Password is required.";
      isValid = false;
    } else if (adminLogin.password.length < 4) {
      newErrors.password = "Password must be at least 4 characters long.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setErrorMessage("");

    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    try {
      const res = await axios.post(API_URL, adminLogin);
      console.log("Login successful, Token:", res.data.token);

      if (res.data.token) {
        localStorage.setItem("token", res.data.token);
        navigate("/admin-dashboard"); // Navigate only if login is successful
      } else {
        setErrorMessage("Invalid username or password.");
      }
    } catch (error) {
      setErrorMessage("Invalid username or password.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: "linear-gradient(to bottom left,#C7E0E3, #FFFFFF ) ",
        height: "90vh", // Example height
        width: "100%", // Example width
      }}
    >
      {/* <div className="logo-container ms-4">
        {logo && <img src={logo} alt="Company Logo" />}
      </div> */}

      <div className="d-flex justify-content-center align-items-center  h-100">
        <div style={{ width: "25rem", padding: "20px", border: "none" }}>
          <h3
            className="text-center mb-4"
            style={{
              color: "#5b807b",
              fontFamily: "Roboto",
              fontWeight: "500",
              fontSize: "30px",
            }}
          >
            Admin/Staff Login
          </h3>
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
          <Form onSubmit={handleSubmit} noValidate>
            <Form.Group className="mb-3 login_page">
              <Form.Control
                style={{ backgroundColor: "#C5CACF", width: "360px" }}
                type="text"
                value={adminLogin.username}
                onChange={(e) =>
                  setAdminLogin({ ...adminLogin, username: e.target.value })
                }
                placeholder="Username"
                isInvalid={!!errors.username}
                className=""
              />
              <Form.Control.Feedback type="invalid">
                {errors.username}
              </Form.Control.Feedback>
            </Form.Group>

            {/* <Form.Group controlId="formPassword">
              <InputGroup>
                <Form.Control
                  placeholder="Password"
                  style={{ backgroundColor: '#C5CACF' }}
                  type={showPassword ? "password" : "text"}
                  value={adminLogin.password}
                  onChange={(e) => setAdminLogin({ ...adminLogin, password: e.target.value })}
                  isInvalid={!!errors.password}
                 
                />
                
                <InputGroup.Text
                  onClick={() => setShowPassword(!showPassword)}
                  style={{ cursor: "pointer", backgroundColor: '#C5CACF', border: "none" }}
                >
                  {showPassword ? <EyeSlashFill /> : <EyeFill />}
                </InputGroup.Text>
                <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
              </InputGroup>
            </Form.Group> */}

            <Form.Group controlId="formPassword">
              <InputGroup className="login_page">
                <Form.Control
                  placeholder="Password"
                  className="login_page"
                  style={{
                    backgroundColor: "#C5CACF",
                    paddingRight: "2.5rem",
                    borderRadius: "5px",
                  }} // Add padding to accommodate the eye icon
                  type={showPassword ? "password" : "text"}
                  value={adminLogin.password}
                  onChange={(e) =>
                    setAdminLogin({ ...adminLogin, password: e.target.value })
                  }
                  isInvalid={!!errors.password}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    zIndex: "10",
                    right: "10px",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    backgroundColor: "transparent",
                    border: "none",
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeSlashFill /> : <EyeFill />}
                  {/* {showPassword ? <FaEyeSlash /> : <FaEye />} */}
                </div>
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            {/* <div className="text-end mt-1">
              <Form.Label style={{ color: '#FF0404', fontFamily: 'Roboto', fontWeight: '300', cursor: 'pointer' }}>
                Forgotten Password?
              </Form.Label>
            </div> */}

            <div className="text-center mt-4">
              <Button
                type="submit"
                disabled={isSubmitting}
                style={{
                  borderRadius: "15px",
                  color: "white",
                  backgroundColor: isSubmitting ? "#B0B0B0" : "#396D72",
                  border: "1px solid #628573",
                  fontFamily: "Roboto",
                  fontWeight: "600",
                  fontSize: "12px",
                }}
                className="pt-2 pb-2 ps-4 pe-4"
              >
                {isSubmitting ? "Signing in..." : "SIGN IN"}
              </Button>
            </div>
          </Form>
        </div>
      </div>

     
    </div>
  );
};

export default Admin;
